import Navigo from 'navigo';

import myAccount from './my-account';
import restorePassword from './restore-password';
import lkOrders from './lk-orders';
import accountInfo from './account-info';

const router = new Navigo('/');
router
    .on({
        '/my-account/login': function () {
            myAccount();
        },
        '/my-account/restore-password': function () {
            restorePassword();
        },
        '/my-account/profile': function () {
            accountInfo();
        },
        '/my-account/orders': function () {
            lkOrders();
        },
        '': function () {

        }
    })
    .resolve();